import axios from "../axios/index.js";

const urlGetlListGallery = "/api/get-list-gallery";

export default {
    getListGallery() {
        return axios.post(urlGetlListGallery);
    },
};
